/**
 * @desc 全局数据
 * @time 2023-07-31 15:49:01
 * @user simxin
 */

import { create } from 'zustand';

type ErrorCode = '' | 'InternalError.GetAppIdError';

interface PortalStore {
  /**
   * @desc 基座加载状态
   */
  loadedPortal: boolean;
  setLoadedPortal: (value: boolean) => void;

  /**
   * @desc 基座失败状态
   */
  errorPortal: boolean;
  setErrorPortal: (value: boolean) => void;

  /**
   * @desc 基座应用加载状态
   */
  loadedApp: boolean;
  setLoadedApp: (value: boolean) => void;

  /**
   * @desc 基座应用失败状态
   */
  errorApp: boolean;
  setErrorApp: (value: boolean) => void;

  /**
   * @desc 基座应用失败码
   */
  errorCode: ErrorCode;
  setErrorCode: (value: ErrorCode) => void;

  /**
   * @desc 用户昵称
   */
  nickname: string;
  setNickname: (value: string) => void;

  /**
   * @desc 用户邮箱
   */
  mail: string;
  setMail: (value: string) => void;

  /**
   * @desc chat 应用
   */
  isChat: boolean;
  setIsChat: (value: boolean) => void;

  /**
   *  @desc 应用
   */
  app: string;
  setApp: (value: string) => void;

  /**
   *  @desc 应用
   */
  menu: string;
  setMenu: (value: string) => void;

  /**
   * @desc 没有开通trtc服务的权限
   */
  isNoOpenTRTCServiceAuth: boolean;
  setIsNoOpenTRTCServiceAuth: (value: boolean) => void;
  /**
   * @desc 非TRTC应用
   */
  notTRTCAppList: any[];
  setNotTRTCAppList: (value: any[]) => void;

  appChangedFlag: boolean;
  setAppChangedFlag: () => void;
}

export const usePortalStore = create<PortalStore>(set => ({
  loadedPortal: false,
  setLoadedPortal: value => set({ loadedPortal: value }),

  errorPortal: false,
  setErrorPortal: value => set({ errorPortal: value }),

  loadedApp: false,
  setLoadedApp: value => set({ loadedApp: value }),

  errorApp: false,
  setErrorApp: value => set({ errorApp: value }),

  errorCode: '',
  setErrorCode: value => set({ errorCode: value }),

  nickname: '',
  setNickname: value => set({ nickname: value }),

  mail: '',
  setMail: value => set({ mail: value }),

  isChat: false,
  setIsChat: value => set({ isChat: value }),

  app: '',
  setApp: value => set({ app: value }),

  menu: '',
  setMenu: value => set({ menu: value }),

  isNoOpenTRTCServiceAuth: false,
  setIsNoOpenTRTCServiceAuth: value => set({ isNoOpenTRTCServiceAuth: value }),

  notTRTCAppList: [],
  setNotTRTCAppList: value => set({ notTRTCAppList: value }),

  appChangedFlag: false,
  setAppChangedFlag: () =>
    set(state => ({ appChangedFlag: !state.appChangedFlag })),

}));
